// ── Multi-level product image zoom (1x → 2x → 4x) ──────────────────────────
// Uses vanilla JS to avoid jQuery version conflicts (two jQuery versions loaded)
(function () {
  var ZOOM_LEVELS = [1, 2, 4];
  var zoomState = new WeakMap();

  function getImg(wrap) {
    var imgs = wrap.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].classList.contains('zoomImg')) return imgs[i];
    }
    return null;
  }

  function setupWrap(wrap) {
    if (zoomState.has(wrap)) return;
    var img = getImg(wrap);
    if (!img) return;

    zoomState.set(wrap, { level: 0 });
    img.style.transition = 'transform 0.12s ease';
    wrap.style.cursor = 'zoom-in';
    wrap.style.overflow = 'hidden';

    function coords(e) {
      var r = wrap.getBoundingClientRect();
      var src = e.touches ? e.touches[0] : e;
      return {
        x: Math.max(0, Math.min(src.clientX - r.left, r.width)),
        y: Math.max(0, Math.min(src.clientY - r.top, r.height))
      };
    }

    function applyZoom(scale, ox, oy) {
      if (scale <= 1) {
        img.style.transform = '';
        img.style.transformOrigin = '';
        wrap.style.cursor = 'zoom-in';
      } else {
        img.style.transform = 'scale(' + scale + ')';
        img.style.transformOrigin = (ox || 0) + 'px ' + (oy || 0) + 'px';
        var state = zoomState.get(wrap);
        wrap.style.cursor = state.level < ZOOM_LEVELS.length - 1 ? 'zoom-in' : 'zoom-out';
      }
    }

    wrap.addEventListener('click', function (e) {
      e.preventDefault();
      var state = zoomState.get(wrap);
      state.level = (state.level + 1) % ZOOM_LEVELS.length;
      var c = coords(e);
      applyZoom(ZOOM_LEVELS[state.level], c.x, c.y);
    });

    wrap.addEventListener('mousemove', function (e) {
      var state = zoomState.get(wrap);
      if (state.level === 0) return;
      var c = coords(e);
      img.style.transformOrigin = c.x + 'px ' + c.y + 'px';
    });

    wrap.addEventListener('mouseleave', function () {
      var state = zoomState.get(wrap);
      state.level = 0;
      applyZoom(1);
    });
  }

  function initAll() {
    var sliders = document.querySelectorAll('[id^="ProductPhotos-"]');
    sliders.forEach(function (slider) {
      slider.querySelectorAll('.photo-zoom-link').forEach(function (wrap) {
        setupWrap(wrap);
      });
    });
  }

  // Run after everything is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initAll, 800); });
  } else {
    setTimeout(initAll, 800);
  }

  // Also re-init on slick slide change (slick fires on the element)
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.product__thumb');
    if (thumb) setTimeout(initAll, 300);
  });
}());

jQuery(document).ready(function ($) {
  $(".collection-slider-inner").owlCarousel({
    loop: true,
    // autoplay: true,
    // autoplayHoverPause: true,
    margin: 10,
    responsiveClass: true,
    nav: true,
    dots: false,
    responsive: {
      0: {
        center: false,
        items: 1
      },
      500: {
        center: false,
        items: 2
      },
      767: {
        center: true,
        items: 3
      },
      1199: {
        center: false,
        items: 4
      }
    }
  });
  $(".p_meta-slider").owlCarousel({
    items: 1,
    loop: true,
    // autoplay: true,
    // autoplayHoverPause: true,
    responsiveClass: true,
    nav: false,
    dots: false,
  });
  $(".p-slider").owlCarousel({
    loop: true,
    // autoplay: true,
    // autoplayHoverPause: true,
    margin: 20,
    responsiveClass: true,
    nav: true,
    dots: false,
    responsive: {
      0: {
        center: false,
        items: 1
      },
      500: {
        center: false,
        items: 2
      },
      767: {
        center: true,
        items: 3
      },
      1199: {
        center: false,
        items: 4
      }
    }
  });

$('.video-btn').click(function(){
  $('.the-video').trigger('play');
  $('.the-video').attr('controls', '');
  $(this).css('display', 'none');
});

$(function () {

  var activeIndex = $('.active-tab').index(),
      $contentlis = $('.tabs-content > li'),
      $tabslis = $('.tabs li');
  
  // Show content of active tab on loads
  $contentlis.eq(activeIndex).show();

  $('.tabs').on('click', 'li', function (e) {
    var $current = $(e.currentTarget),
        index = $current.index();
    
    $tabslis.removeClass('active-tab');
    $current.addClass('active-tab');
    $contentlis.hide().eq(index).show();
	 });
});

$(".mega-hover").hover(function(){
  let mega_wrap = $('.mega-wrap-outer');
  let $this = $(this);
  if (mega_wrap.hasClass('display')) {
    $this.find(".mega-wrap-outer").stop(true,true).removeClass("display");
  }
  else {
    $this.find(".mega-wrap-outer").stop(true,true).addClass("display");
  }
  
});
});



const accordionItemHeaders = document.querySelectorAll(
  ".accordion-item-header"
);

accordionItemHeaders.forEach((accordionItemHeader) => {
  accordionItemHeader.addEventListener("click", (event) => {
    // Uncomment in case you only want to allow for the display of only one collapsed item at a time!

    const currentlyActiveAccordionItemHeader = document.querySelector(
      ".accordion-item-header.active"
    );
    if (
      currentlyActiveAccordionItemHeader &&
      currentlyActiveAccordionItemHeader !== accordionItemHeader
    ) {
      currentlyActiveAccordionItemHeader.classList.toggle("active");
      currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
    }
    accordionItemHeader.classList.toggle("active");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});